'use strict';
let xhScript = {
    data() {
        return{
            xhShow: false,
            xhList: [],
            xhForm: {},
            xhData: {},
            xhConfirmList: [],
            xhBoxOptions: [],
            xhConfirmShow: false,
            xhDeferVisible: false,
            xhDeferValidateRules: {
                DELAY_QTY: [
                    {required: true, message: this.$t('pleaseFillInTheNumberOfDelayedBoxes'), trigger: ['blur', 'change']},
                    // {
                    //     validator: (rule, value, callback) => {
                    //         if (value > (this.xhDeferForm.REAL_QTY - this.xhDeferForm.ORDER_QTY - this.xhDeferForm.TERM_QTY)) {
                    //             callback('延期箱量超过可延期箱量')
                    //         } else {
                    //             callback()
                    //         }
                    //     }
                    // }
                ],
                DELAY_END_DATE: [{required: true, message: this.$t('pleaseFillInTheExtensionDate'), trigger: ['blur', 'change']}],
            },
            xhValidateRules: {
                RET_DATE: [{required: true, message: this.$t('PleaseSelectReturnDate'), trigger: ['blur', 'change']}],
                GUID_CODES: [{required: true, message: this.$t('pleaseUploadTheReturnCertificate'), trigger: ['blur', 'change']}],
                BOX_ARR: [{required: true, message: this.$t('pleaseSelectTheCaseCode'), trigger: ['blur', 'change']}],
            },
            xhOrderValidateRules:{
                RET_DATE: [{required: true, message: this.$t('pleaseSelectAReturnDate'), trigger: ['blur', 'change']}],
                GUID_CODES: [{required: true, message: this.$t('pleaseUploadTheReturnCertificate'), trigger: ['blur', 'change']}],
            },
            xhDeferForm: {},
            xhParamsData:{
                "SYS_TYPE": "20011003",
                "TARGET_CATE": "20021011",
                "TARGET_TYPE": "20071003",
                "TARGET_ID": "",
                "GUID_CODE":""
            }
        }
    },
    computed:{
      xhColumns(){
        let columns = [];
        columns.push({dataIndex: 'BOX_CODE', title: this.$t('container'), scopedSlots: {customRender: 'BOX_CODE'}});
        columns.push({dataIndex: 'BEGIN_DATE', title: this.$t('returnBoxInstructionsIndate'), scopedSlots: {customRender: 'BEGIN_DATE'}});
        columns.push({dataIndex: 'RET_DATE', title: this.$t('returnBoxTime'), scopedSlots: {customRender: 'RET_DATE'}});
        columns.push({dataIndex: 'RET_STATUS', title: this.$t('returnInstructionsStatus'), scopedSlots: {customRender: 'RET_STATUS'}});
        columns.push({dataIndex: '_id', title: this.$t('operate'),width: '120px', scopedSlots: {customRender: 'operation'}});
        return columns;
      },
      getXhBoxMap(){
          let xhData = {};
          this.xhList.forEach(item =>{
              item.BOX_CODE_ARR?.forEach(box =>{
                  xhData[box.BOX_CODE] = {
                      MASTER_ID: item.MASTER_ID,
                      FLOW_ID: box.FLOW_ID,
                      END_DATE: item.END_DATE,
                      XH_FILE_GUID_CODE: box.XH_FILE_GUID_CODE,
                      RET_SPACE_ID: item.RET_SPACE_ID,
                  }
              })
          })
          return xhData;
      },
    },
    methods: {
        xhFinished(data){
            this.$set(this.xhForm,'GUID_CODES',data?.FILE_LIST?.[0]?.['GUID_CODE']);
        },
        downloadXhFile(data){
            let fileUrl;
            if(this.xhFileMap[data.MASTER_ID + '20011002']){
                fileUrl = this.xhFileMap?.[data.MASTER_ID + '20011002']?.FILE_NAME;
            }else {
                fileUrl = this.xhFileMap?.[data.MASTER_ID + '20011001']?.FILE_NAME;
            }
            this.$Dolphin.download(this.$t('returnBoxInstructions'), this.$Dolphin.path.filePath +fileUrl)
            /*let condition = {
                "SYS_TYPE":"20011003",
                "TARGET_CATE":"20021011",
                "TARGET_TYPE":"20071003",
                "TARGET_ID": data.MASTER_ID
            }
            this.$h5Api({
                type: '2021',
                data: [condition],
            }).then(({data}) => {
                this.$Dolphin.download('还箱指令', this.$Dolphin.path.filePath + data?.FILE_LIST?.[0]?.FILE_NAME)
            })*/
        },
        openXhDelay(data,boolean) {
            this.xhDeferForm = Object.assign({}, data);
            if(boolean){
                this.xhDeferForm.boxArr.map(item => {
                    item.label = item.BOX_CODE;
                    item.value = item.FLOW_ID;
                    item.disabled = item.RET_STATUS && item.RET_STATUS >= 4 && item.RET_STATUS !== 6; // 申请过延期的可以继续申请
                    return item
                })
            }
            this.xhDeferForm.xhDelayFlag = boolean
            this.xhDeferVisible = true;
        },

        /**
         * 申请延期
         */
        confirmXhDelay() {
            let condition = []
            if(this.xhDeferForm.xhDelayFlag) {
                if(!this.xhDeferForm.BOX_CODE_ARR || this.xhDeferForm.BOX_CODE_ARR.length === 0){
                    this.$message.error(this.$t('通用_请至少选择一个箱号'));
                    return false;
                }
                this.xhDeferForm.BOX_CODE_ARR?.forEach(item =>{
                    condition.push({
                        "OPER_TYPE": 0,
                        "MASTER_ID": this.xhDeferForm.MASTER_ID,
                        "FLOW_ID": item,
                        "DELAY_QTY": 1,
                        "DELAY_END_DATE": this.xhDeferForm.DELAY_END_DATE,
                        "DELAY_DESC": this.xhDeferForm.DELAY_DESC || '',
                    })
                })
            } else {
                condition.push({
                    "OPER_TYPE": 0,
                    "MASTER_ID": this.xhDeferForm.MASTER_ID,
                    "FLOW_ID": this.xhDeferForm.FLOW_ID,
                    "DELAY_QTY": 1,
                    "DELAY_END_DATE": this.xhDeferForm.DELAY_END_DATE,
                    "DELAY_DESC": this.xhDeferForm.DELAY_DESC || '',
                })
            }
            if (this.loading) {
                this.loading = false;
                this.$h5Api({
                    type: '4037',
                    data: condition,
                }).then(({data}) => {
                    this.xhDeferVisible = false;
                    this.$message.info(this.$t('confirmationSuccessful'))
                    this.getOrderDetail(this.$route.query.MASTER_ID);
                }).finally(() => {
                    this.loading = true;
                })
            }
        },
        openXhModal(data){
            let xhData = Object.assign({}, data);
            if(this.$moment().isBefore(data.END_DATE)){
                xhData.RET_DATE = this.$moment().format('YYYY-MM-DD HH:mm:ss')
            }else{
                xhData.RET_DATE = data.END_DATE
            }
            this.xhShow = true;
            this.xhForm = xhData;
        },
        openAllConfirmXhOrder(){
            let xhConfirmList = this.selectedRows;
            let xhBoxOptions = [];
            let xhForm = {};
            xhForm.BOX_ARR = [];
            xhConfirmList.forEach(item =>{
                let xhData = {};
                xhData['label'] = item.BOX_CODE;
                xhData['value'] = JSON.stringify(item);
                xhBoxOptions.push(xhData);
                xhForm.BOX_ARR.push(JSON.stringify(item));
            })
            this.xhForm = xhForm;
            this.xhBoxOptions = xhBoxOptions;
            this.xhConfirmShow = true;
        },
        allConfirmXhOrder(){
            let condition = [];let xhData = {};
            this.xhForm.BOX_ARR.forEach(item =>{
                xhData = {
                    "MASTER_ID": JSON.parse(item).MASTER_ID,
                    "FLOW_ID": JSON.parse(item).FLOW_ID,
                    "CHECK_DESC": this.xhForm.CHECK_DESC || '',
                    "RET_DATE": this.$moment(this.xhForm.RET_DATE).format('YYYY-MM-DD')
                }
                condition.push(xhData)
            })
            this.$refs.xhAllForm.validate(val =>{
                if(val){
                    if(this.loading){
                        this.loading = false;
                        this.$h5Api({
                            type: '4040',
                            data: condition,
                        }).then(({data}) => {
                            this.xhConfirmShow = false;
                            this.selectedRows = [];
                            this.selectedRowKeys = [];
                            this.$message.info(this.$t('confirmationSuccessful'))
                            this.getOrderDetail(this.$route.query.MASTER_ID);
                        }).finally(() =>{
                            this.loading = true;
                        })
                    }
                }
            })
        },
        /**
         * 确认还箱
         */
        confirmXhOrder(){
            let condition = {};
            condition = {
                "MASTER_ID": this.xhForm.MASTER_ID,
                "FLOW_ID": this.xhForm.FLOW_ID,
                "CHECK_DESC": this.xhForm.CHECK_DESC || '',
                "GUID_CODES": this.xhForm.GUID_CODES,
                "RET_DATE": this.$moment(this.xhForm.RET_DATE).format('YYYY-MM-DD')
            }
            if(this.xhForm.GUID_CODES && this.xhForm.GUID_CODES instanceof Array){
                condition.GUID_CODES = this.xhForm.GUID_CODES.map(item => {
                    if(typeof item === 'object'){
                        return item.GUID_CODE;
                    }else{
                        return item;
                    }
                }).join(',');
            }else{
                condition.GUID_CODES = this.xhForm.GUID_CODES;
            }
            if(this.loading){
                this.loading = false;
                this.$h5Api({
                    type: '4040',
                    data: [condition],
                }).then(({data}) => {
                    this.xhShow = false;
                    this.$message.info(this.$t('confirmationSuccessful'))
                    this.getOrderDetail(this.$route.query.MASTER_ID);
                }).finally(() =>{
                    this.loading = true;
                })
            }
        },
    },
    created() {
    }
};

export default xhScript;